<div class="breadcrumb-bar" data-element="breadcrumb-bar" *ngIf="this.hasAny"
     (click)="this.onBarClicked()">
  <span class="chip"
        *ngFor="let chip of this.chips; trackBy: this.trackByKey"
        [class.stale]="chip.stale"
        [class.changed]="chip.changed"
        [attr.data-element]="chip.key">{{ chip.text }}<span class="norm-badge" *ngIf="chip.normalized"
        title="Normalized">N</span></span>
  <span class="edit-hint" data-element="breadcrumb-edit-hint">Click to Edit</span>
</div>
